export enum PreviewImage {
  DROPBAR_BIKE = 'preview-dropbar-bike',
  DROPBAR_HANDLEBAR = 'preview-dropbar-handlebar',
  DROPBAR_HOODS = 'preview-dropbar-hoods',
  FLATBAR_BIKE = 'preview-flatbar-bike',
  FLATBAR_GRIPS = 'preview-flatbar-grips',
  FLATBAR_HANDLEBAR = 'preview-flatbar-handlebar',
  TRIBAR_BIKE = 'preview-tribar-bike',
  TRIBAR_HANDLEBAR = 'preview-tribar-handlebar',
  TRIBAR_PADS = 'preview-tribar-pads',
  SADDLE = 'preview-saddle',
}
